import { html } from "src/components/HtmlViewer/utils";
import * as GQL from "src/types/graphql";

export const FORM_ADMIN_CANCELLED = {
  type: GQL.message_template_type_enum.FormAdminCancelled,
  emailSubject: "Your {{organization.name}} form has been canceled",
  emailHtml: html`<p>
    Dear {{parent.name}},<br />
    <br />
    Your {{organization.name}} form for {{student.name}} for the
    {{enrollmentPeriod.name}} has been canceled by an administrator.<br />
    <br />
    If you believe this was a mistake, please contact the {{organization.name}}
    team.<br />
  </p>`,
  emailText: `Dear {{parent.name}},

Your {{organization.name}} form for {{student.name}} for the {{enrollmentPeriod.name}} has been canceled by an administrator.

If you believe this was a mistake, please contact the {{organization.name}} team.`,
  sms: "Your {{organization.name}} form for {{student.name}} has been canceled. Contact {{organization.name}} with any questions.",
};
